import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { useAuthStore } from '@/stores/auth'
import {
  LoginRequest,
  LoginResponse,
  ApiResponse,
  ChangePasswordRequest,
} from '@magnetar/admin-api-interfaces'
import { logger } from '@magnetar/utils'

// 帳號啟用請求介面
interface ActivateAccountRequest {
  account: string
  temp_password: string
  new_password: string
  new_password_confirm: string
}

export const authService = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    try {
      const response = await apiClient.post<LoginResponse>('/api/login', data, {
        headers: { 'Skip-Auth': true },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as LoginResponse
      }
      return {
        success: false,
      }
    }
  },

  logout: async (token: string) => {
    try {
      // Call backend to logout and clear Redis token
      await apiClient.post('/api/logout', null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      // Clear local token
      const { clearToken } = useAuthStore.getState()
      clearToken()

      return { success: true }
    } catch (error) {
      logger.error('登出失敗', error)
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'LOGOUT_FAILED',
          message: '登出時發生錯誤',
        },
      }
    }
  },

  // 首次登入帳號啟用（使用暫時密碼設定新密碼）
  activateAccount: async (data: ActivateAccountRequest): Promise<ApiResponse<null>> => {
    try {
      const response = await apiClient.post<ApiResponse<null>>('/api/activate-account', data, {
        headers: { 'Skip-Auth': true },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ApiResponse<null>
      }
      return {
        success: false,
        error: {
          code: 'ACTIVATE_FAILED',
          message: '帳號啟用失敗',
        },
      }
    }
  },

  // 更改密碼
  changePassword: async (data: ChangePasswordRequest, token: string): Promise<ApiResponse<null>> => {
    try {
      const response = await apiClient.post<ApiResponse<null>>('/api/change-password', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ApiResponse<null>
      }
      return {
        success: false,
        error: {
          code: 'CHANGE_PASSWORD_FAILED',
          message: '密碼更改失敗',
        },
      }
    }
  },
}
